import React, { useMemo } from 'react';
import { orderIDRenderer, statusFormatter, marginFormatter } from '../formatters';
import { Badge } from '@cargomatic/ui';
import { titleize, humanize } from 'underscore.string';
import i18next from 'i18next';
import { getBillingStatusBadgeColor } from 'helpers/status-bar';
export const orderColumns = [
    {
        headerName: 'Order ID',
        field: 'order_id',
        width: 150,
        cellRenderer: orderIDRenderer,
        filter: 'textFilterWithExclude',
        pinned: 'left',
        checkboxSelection: true,
        headerCheckboxSelection: true,
    },
    {
        headerName: 'Status',
        field: 'status',
        width: 120,
        cellRenderer: statusFormatter,
        filter: 'agSetColumnFilter',
        filterParams: {
            values: ['Booking', 'Booked', 'Canceled', 'Complete'],
        },
    },
    {
        headerName: 'Billing Status',
        field: 'billing_status',
        width: 180,
        cellRenderer: ({ value }) => {
            if (!value)
                return null;
            return (React.createElement(Badge, { color: getBillingStatusBadgeColor(value) }, titleize(humanize(i18next.t(value)))));
        },
        filter: 'agSetColumnFilter',
        filterParams: {
            values: ['pending', 'invoiced', 'paid', 'overdue', 'dispute'],
        },
    },
    {
        headerName: 'Customer',
        field: 'customer',
        width: 200,
        filter: 'textFilterWithExclude',
    },
    {
        headerName: 'Origin',
        field: 'origin',
        width: 150,
        filter: 'textFilterWithExclude',
    },
    {
        headerName: 'Destination',
        field: 'destination',
        width: 150,
        filter: 'textFilterWithExclude',
    },
    {
        headerName: 'Total Revenue',
        field: 'total_revenue',
        width: 140,
        filter: 'agNumberColumnFilter',
        type: 'rightAligned',
        cellClass: 'text-right',
        valueFormatter: (params) => { var _a; return `$${((_a = params.value) === null || _a === void 0 ? void 0 : _a.toFixed(2)) || '0.00'}`; },
    },
    {
        headerName: 'Total Cost',
        field: 'total_cost',
        width: 130,
        filter: 'agNumberColumnFilter',
        type: 'rightAligned',
        cellClass: 'text-right',
        valueFormatter: (params) => { var _a; return `$${((_a = params.value) === null || _a === void 0 ? void 0 : _a.toFixed(2)) || '0.00'}`; },
    },
    {
        headerName: 'Margin',
        field: 'margin',
        width: 120,
        filter: 'agNumberColumnFilter',
        type: 'rightAligned',
        cellClass: 'text-right',
        valueFormatter: (params) => { var _a; return `$${((_a = params.value) === null || _a === void 0 ? void 0 : _a.toFixed(2)) || '0.00'}`; },
    },
    {
        headerName: 'Margin %',
        field: 'margin_percentage',
        width: 110,
        filter: 'agNumberColumnFilter',
        type: 'rightAligned',
        valueFormatter: (params) => `${params.value}%`,
        cellClass: 'text-right',
    },
    {
        headerName: 'Containers',
        field: 'containers',
        width: 180,
        filter: 'textFilterWithExclude',
        valueFormatter: (params) => params.value ? params.value.join('\n') : '',
        cellStyle: { 'white-space': 'pre-wrap', 'overflow': 'hidden', 'text-overflow': 'ellipsis' },
        autoHeight: true,
    },
    {
        headerName: 'Chassis',
        field: 'chassis',
        width: 140,
        filter: 'textFilterWithExclude',
        cellStyle: { 'white-space': 'nowrap', 'overflow': 'hidden', 'text-overflow': 'ellipsis' },
        autoHeight: true,
    },
    {
        headerName: 'Vessel',
        field: 'vessel',
        width: 160,
        filter: 'textFilterWithExclude',
        cellStyle: { 'white-space': 'normal', 'overflow': 'hidden' },
        autoHeight: true,
    },
    {
        headerName: 'Ocean Carrier',
        field: 'ocean_carrier',
        width: 150,
        filter: 'agSetColumnFilter',
        filterParams: {
            values: ['MSC', 'COSCO', 'Evergreen', 'OOCL', 'Maersk', 'CMA CGM'],
        },
    },
];
export const useOrderColumns = () => {
    return useMemo(() => orderColumns, []);
};
